import script from "./MediaInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./MediaInput.vue?vue&type=script&lang=ts&setup=true"

import "./MediaInput.vue?vue&type=style&index=0&id=35a1214c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a1214c"]])

export default __exports__